import { render, staticRenderFns } from "./AssignUserToSubItem.vue?vue&type=template&id=a80096e8&"
import script from "./AssignUserToSubItem.vue?vue&type=script&lang=js&"
export * from "./AssignUserToSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports